import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './met-category.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MetCategoryDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const metCategoryEntity = useAppSelector(state => state.metCategory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="metCategoryDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.metCategory.detail.title">MetCategory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{metCategoryEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.metCategory.code">Code</Translate>
            </span>
          </dt>
          <dd>{metCategoryEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.metCategory.name">Name</Translate>
            </span>
          </dt>
          <dd>{metCategoryEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.metCategory.nameAr">Name Ar</Translate>
            </span>
          </dt>
          <dd>{metCategoryEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.metCategory.nameEn">Name En</Translate>
            </span>
          </dt>
          <dd>{metCategoryEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.metCategory.status">Status</Translate>
            </span>
          </dt>
          <dd>{metCategoryEntity.status}</dd>
          <dt>
            <span id="abreviation">
              <Translate contentKey="almobadaraMasterDataApp.metCategory.abreviation">Abréviation</Translate>
            </span>
          </dt>
          <dd>{metCategoryEntity.abreviation}</dd>
        </dl>
        <Button tag={Link} to="/met-category" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/met-category/${metCategoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MetCategoryDetail;
